import React from 'react'
import styled from '@emotion/styled'

const Cards = styled('div')`background-color: ${props => props.theme.card};
-webkit-box-shadow:${props => props.theme.shadow}`;

const CoreDetails = (props) => {
    return (
		<Cards style={{transitionDelay: `${props.delay}ms`}} className={`information-cards-container ${props.name}`}>
            <div style={{width: `${props.percentage}%`}} className="information-card-percentage"> </div>
            <div className="_1-grid">
				<div className="main-stat">
					<h3>Cores</h3>
					<h2>{props.data.coreCount}</h2>
				</div>
            </div>
        </Cards>
    )
};
export default CoreDetails
